import { render, staticRenderFns } from "./ExportStaffInsuranceLog.vue?vue&type=template&id=bee64fe8"
import script from "./ExportStaffInsuranceLog.vue?vue&type=script&lang=js"
export * from "./ExportStaffInsuranceLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports